export default __webpack_public_path__ + "static/media/googleAuth.396cfc98.svg";